<template>
  <div class="old-page-content">
    <div class="dynamic-container" v-if="userinfo">
      <div class="circle-top">
        <img
          class="avatar"
          :src="userinfo.u_img || defaultAvatar[0]"
          @click.stop="jumpUserinfo(item)"
        />
        <div class="user-info">
          <div class="name-content">
            <span class="true-name">{{
              userinfo.remark_name || userinfo.u_name
            }}</span>
            <span
              class="gender iconfont"
              :class="[formatGenderIcon(userinfo.gender)]"
            ></span>
          </div>
          <div class="nickname">
            <span v-if="userinfo.nickname">({{ userinfo.nickname }})</span>
          </div>
        </div>
        <div class="add-time">{{ userinfo.addtime }}发布</div>
      </div>
      <AllDayDetail
        v-if="userinfo.group_all_day"
        :data="userinfo.group_all_day"
      ></AllDayDetail>
      <div class="circle-center" v-else>
        <div class="content" v-if="userinfo.say">
          <span>{{ userinfo.say }}</span>
        </div>
        <div class="image-list">
          <van-image
            @click.stop="previewImage(index1, userinfo.content)"
            class="image-item"
            :class="{
              'image-item-50': userinfo.content.length > 1,
              'image-item-100': userinfo.content.length <= 1
            }"
            v-for="(imgitem, index1) in userinfo.content"
            :key="index1"
            :src="formatImageUrl(imgitem)"
            fit="cover"
            radius="8px"
          />
        </div>
        <div class="data-diff" v-if="userinfo.date_diff"
          >对比{{ userinfo.date_diff }}天前</div
        >
        <div class="data-info" v-if="userinfo.p_type == 2">
          <div class="data-item"
            ><span class="d-text">体重: </span
            ><span class="d-num">{{ userinfo.weight }}</span
            ><span class="d-unit">kg</span
            ><span
              class="d-div"
              :class="[userinfo.weight_ratio > 0 ? 'd-red' : 'd-green']"
              ><span
                class="iconfont icon-xiala"
                :class="{ rotate: userinfo.weight_ratio > 0 }"
              ></span
              ><span class="change-num">{{
                Math.abs(userinfo.weight_ratio)
              }}</span></span
            ></div
          >
          <div class="data-item"
            ><span class="d-text">腰围: </span
            ><span class="d-num">{{ userinfo.waist }}</span
            ><span class="d-unit">cm</span
            ><span
              class="d-div"
              :class="[userinfo.waist_ratio > 0 ? 'd-red' : 'd-green']"
              ><span
                class="iconfont icon-xiala"
                :class="{ rotate: userinfo.waist_ratio > 0 }"
              ></span
              ><span class="change-num">{{
                Math.abs(userinfo.waist_ratio)
              }}</span></span
            ></div
          >
          <div class="data-item" v-if="userinfo.thigh_r"
            ><span class="d-text">大腿围: </span
            ><span class="d-num">{{ userinfo.thigh_r }}</span
            ><span class="d-unit">cm</span
            ><span
              class="d-div"
              :class="[userinfo.thigh_ratio > 0 ? 'd-red' : 'd-green']"
              ><span
                class="iconfont icon-xiala"
                :class="{ rotate: userinfo.thigh_ratio > 0 }"
              ></span
              ><span class="change-num">{{
                Math.abs(userinfo.thigh_ratio)
              }}</span></span
            ></div
          >
          <!-- <div class="data-item"
            ><span class="d-text">BMI: </span><span class="d-num">{{ 30 }}</span
            ><span class="d-div" :class="[true ? 'd-red' : 'd-green']"
              ><span
                class="iconfont icon-xiala"
                :class="{ rotate: true }"
              ></span
              ><span class="change-num">{{ Math.abs(28) }}</span></span
            ></div
          >
          <div class="data-item"
            ><span class="d-text">体脂率: </span
            ><span class="d-num">{{ 30 }}</span
            ><span class="d-div" :class="[true ? 'd-red' : 'd-green']"
              ><span
                class="iconfont icon-xiala"
                :class="{ rotate: true }"
              ></span
              ><span class="change-num">{{ Math.abs(32.5) }}</span></span
            ></div
          >
          <div class="data-item"
            ><span class="d-text">身体年龄: </span
            ><span class="d-num">{{ 20 }}</span></div
          > -->
        </div>
      </div>
      <!-- 标签 -->
      <div class="label-list" v-if="userinfo.topic.length">
        <div
          class="tag-item"
          v-for="(tagitem, index) in userinfo.topic"
          :key="index"
        >
          #{{ tagitem }}
        </div>
      </div>
      <div class="title">
        <span>评论</span>
        <span class="today-reviews" @click.stop="previewToday"
          >查看当日餐卡点评</span
        >
      </div>
      <div class="comment-container">
        <!-- 禁止输入的输入框 -->
        <div class="comment-box">
          <van-field
            :disabled="!canEdit"
            v-model="coachInput"
            rows="4"
            label=""
            type="textarea"
            placeholder="请仔细阅读会员描述和图片,再进行点评"
            :maxlength="maxLength"
            show-word-limit
          />
        </div>
      </div>
      <template v-if="![2, 7].includes(userinfo.p_type)">
        <div class="title">异常描述</div>
        <div class="comment-container">
          <div class="desc-box">
            <van-field
              :disabled="!canEdit"
              v-model="exceptionInput"
              rows="3"
              label=""
              type="textarea"
              placeholder="请填写餐卡不满分原因。如无异常，可不填写"
              :maxlength="exceptionMaxLength"
              show-word-limit
            />
            <!--  <textarea
              class="error-area"
              placeholder="请填写餐卡不满分原因。如无异常，可不填写"
              :maxlength="exceptionMaxLength"
              v-model="exceptionInput"
            ></textarea> -->
          </div>
        </div>
      </template>
      <div
        v-if="
          userinfo.p_type == 3 || userinfo.p_type == 6 || userinfo.p_type == 7
        "
      >
        <div class="tag-content" v-for="(item, index) in tagList" :key="index">
          <div class="tag-type">{{ item.name }}</div>
          <div class="tag-list">
            <div
              class="tag-item"
              :class="{ 'tag-item-active': item1.active }"
              v-for="(item1, index1) in item.list"
              :key="index1"
              @click.stop="selectTag(index, index1)"
            >
              {{ item1.name }}
            </div>
          </div>
        </div>
      </div>
      <template v-if="userinfo.p_type != 2">
        <div class="title">打分</div>
        <div class="score-content">
          <ScoreContent
            v-if="userinfo"
            :data="userinfo"
            @change="changeScore"
            :edit="canEdit"
            :showStar="userinfo.p_type == 7 ? false : true"
          ></ScoreContent>
        </div>
      </template>
      <div v-if="userinfo.p_show == 1">
        <div class="review-time">点评时间: {{ userinfo.p_time }}</div>
        <div class="review-duration">点评用时: {{ reviewTime }}</div>
      </div>
      <div class="del-content" v-if="userinfo.p_show == 1">
        <div class="del-btn" @click.stop="showDelComment">删除点评</div>
      </div>
      <div class="btn-content">
        <div class="btn-item save-btn" @click.stop="showSubmit(2)">保存</div>
        <div
          class="btn-item release-btn"
          :class="{ 'disabled-release': disabledSubmit }"
          @click.stop="showSubmit(1)"
        >
          发布点评
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ImagePreview } from 'vant'
import { dietRatioTextList, featuresTextList } from './data'
import ScoreContent from '../components/score-content.vue'
import AllDayDetail from '../components/all-day-detail.vue'
export default {
  components: {
    ScoreContent,
    AllDayDetail
  },
  data() {
    return {
      coachId: '',
      autoSizeObj: { maxHeight: 200, minHeight: 100 },
      tab_type: '',
      id: '',
      buttonHeight: 0,
      defaultAvatar: [
        'https://cdnvue.gymcity.com.cn/uploads/b2ae63e6c8ce86d5ad1cbd0ab233ce83.png',
        'https://cdnvue.gymcity.com.cn/uploads/1ce985d5712871e05b0d65e638924a29.png',
        'https://cdnvue.gymcity.com.cn/uploads/b2ae63e6c8ce86d5ad1cbd0ab233ce83.png'
      ],
      pid: '',
      index: '',
      submiting: false, //是否正在提交
      userinfo: null,
      maxLength: 2000,
      minLength: 60,
      exceptionMaxLength: 20, //异常描述最长文字
      coachInput: '', //教练评论内容
      exceptionInput: '', //异常描述
      scoreParams: {
        0: 'star',
        1: 'p_food_weight',
        2: 'p_staple_ratio',
        3: 'p_protein_ratio',
        4: 'p_vegetable_ratio',
        5: 'p_soy_milk'
      },
      reviewTime: '', //点评时长
      scoreData: null,
      tagList: [],
      maxSelectTag: 3,
      disabledSubmit: false,
      submitTypeArr: ['', '发布', '保存'],
      focusComment: false, //是否已经聚焦了输入框
      commentHeight: 0, //输入键盘的高度
      isphone: true, //是否是手机
      inputInfo: {}, //输入框的一些信息
      curInputIndex: '', //当前输入框index
      inputInfoList: [
        {
          title: '评论',
          maxLength: 2000,
          placeholder: '请仔细阅读会员描述和图片,再进行点评'
        },
        {
          title: '异常描述',
          maxLength: 20,
          placeholder: '请填写餐卡不满分原因。如无异常，可不填写'
        }
      ],
      fixedInput: '',
      featuresInputList: [], //根据选择特点的建议列表
      featuresTextList,
      dietRatioTextList, //饮食比例文案
      canEdit: false
    }
  },
  watch: {},
  created() {
    if (this.$route.query) {
      this.tab_type = this.$route.query.tabType || ''
      this.id = this.$route.query.id || ''
      this.index = this.$route.query.index || 0
      this.pid = this.$route.query.pid || ''
    }
    this.coachId = localStorage.getItem('coachId')
    /* 获取草稿 */
    this.getLocalStorage()
    this.getDetail()
  },
  methods: {
    formatGenderIcon(gender) {
      var res = ''
      if (gender == 1) {
        res = 'icon-nan-5'
      } else if (gender == 2) {
        res = 'icon-nv-3'
      } else {
        res = 'icon-wenhao4'
      }
      return res
    },
    formatImageUrl(imageUrl) {
      imageUrl = imageUrl + '?x-oss-process=image/resize,w_300/quality,Q_80'
      if (imageUrl.indexOf('_heic_')) {
        imageUrl = imageUrl + '/format,png'
      }
      return imageUrl
    },
    //设置饮食比例文案
    setDietRatioText(data) {
      let arr = []
      for (let i = 0; i < data.length; i++) {
        for (let j = 0; j < this.dietRatioTextList.length; j++) {
          if (data[i].name == this.dietRatioTextList[j].title) {
            let obj
            if (data[i].score < 3) {
              obj = this.dietRatioTextList[j].list[0]
            } else if (data[i].score == 3) {
              obj = this.dietRatioTextList[j].list[1]
            } else {
              obj = this.dietRatioTextList[j].list[2]
            }
            obj && arr.push(obj)
            break
          }
        }
      }
      arr.map((item, index) => {
        if (item.text) {
          this.coachInput =
            this.coachInput + (this.coachInput === '' ? '' : '\n\n') + item.text
        }
      })
      this.coachInput = this.coachInput.slice(0, this.maxLength)
    },
    //更新文案的顺序
    updateDescText(data) {
      data = data.sort((a, b) => {
        return (b.zIndex || 0) - a.zIndex
      })
      this.featuresInputList = data
    },
    //添加饮食比例文案
    addDietRatioTexts(data) {
      data.map((item) => {
        //过滤掉重复的
        let isExist = false
        for (let i = 0; i < this.featuresInputList.length; i++) {
          let item1 = this.featuresInputList[i]
          if (item1.id === item.id) {
            isExist = i
          }
        }
        let obj = {
          id: item.id,
          title: item.title,
          text: item.text,
          zIndex: item.zIndex
        }
        if (isExist === false) {
          this.featuresInputList.push(obj)
        } else {
          this.featuresInputList[isExist] = obj
        }
      })
      this.featuresInputList = this.featuresInputList.filter((item) => {
        return item.text !== ''
      })
      this.updateDescText(this.data.featuresInputList)
    },
    //新增饮食建议时
    bindAddInput() {
      this.featuresInputList.push({
        id: 0,
        title: '',
        text: '',
        zIndex: 0
      })
      this.updateDescText(this.featuresInputList)
    },
    //查看今日打卡点评
    previewToday() {
      let addTime = this.userinfo.addtime.slice(0, 10) || ''
      this.$router.push({
        path: '/nutritionist-tool/today-review',
        query: {
          uid: this.userinfo.unify_id,
          nickname: this.userinfo.u_name,
          addTime
        }
      })
      //  wx.setStorageSync("todayReviews", this.data.userinfo);
    },
    //查看动态大图
    previewImage(index, list) {
      ImagePreview({
        images: list,
        startPosition: index
      })
    },
    //评分改变时
    changeScore(scoreData, itemData) {
      console.log('评分改变')
      if (this.userinfo.p_type == 7) {
        //观察期默认星级为5
        scoreData = scoreData.map((item) => {
          if (item.type == 'star') {
            item.score = 5
          }
          return item
        })
        if (Array.isArray(itemData) && !this.coachInput) {
          // 改变饮食比例的文案
          this.setDietRatioText(itemData)
        } else {
          this.setDietRatioText([itemData])
        }
      }
      this.scoreData = scoreData
    },
    //获取到选中的tag标签 用,分割
    getTagId(data, index) {
      let arr = []
      data[index].list.map((item) => {
        if (item.active) {
          arr.push(item.id)
        }
      })
      let str = arr.join(',')
      return str
    },
    showDelComment() {
      this.$dialog
        .confirm({
          title: '提示',
          message: '确认删除点评?'
        })
        .then(() => {
          this.delComment()
        })
        .catch(() => {
          // on cancel
        })
    },
    showSubmit(submitType) {
      if (this.disabledSubmit) {
        return
      }
      if (this.coachInput.length < this.minLength) {
        this.$toast('字数必须大于' + this.minLength + '字')
        return
      }
      if (this.coachInput === '') {
        this.$toast('请输入点评内容')
        return
      }
      let star = 0
      this.scoreData?.map((item) => {
        if (item.type == 'star') {
          star = item.score
        }
      })
      if (
        star < 5 &&
        ![2, 7].includes(this.userinfo.p_type) &&
        this.exceptionInput === ''
      ) {
        this.$toast('1-4星必须填写异常')
        return
      }
      this.$dialog
        .confirm({
          title: '提示',
          message: '确认' + this.submitTypeArr[submitType] + '点评?'
        })
        .then(() => {
          this.submit(submitType)
        })
        .catch((err) => {
          console.log(err)
          // on cancel
        })
    },
    delComment() {
      let params = {
        pid: this.pid,
        cid: localStorage.getItem('coachId'),
        gid: (this.userinfo && this.userinfo.id) || ''
      }
      this.$http
        .postApp('member/AppCampCoach/delCoachComment', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.userinfo.p_show = 0
            this.disabledSubmit = false
            this.canEdit = true
            this.$toast('删除成功')
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
        .finally(() => {
          this.submiting = false
        })
    },
    computeTime() {
      if (!this.userinfo.addtime || !this.userinfo.p_time) {
        return
      }
      let addtime = new Date(this.userinfo.addtime.replace(/-/g, '/')).getTime()
      let reviewTime = new Date(
        this.userinfo.p_time.replace(/-/g, '/')
      ).getTime()
      let time = (reviewTime - addtime) / 1000
      let day = parseInt(time / (60 * 60 * 24))
      let hours = parseInt((time % (60 * 60 * 24)) / (60 * 60))
      let min = parseInt(((time % (60 * 60 * 24)) % (60 * 60)) / 60)
      day = day ? day + '天' : ''
      hours = hours ? hours + '小时' : ''
      min = min ? min + '分' : ''
      this.reviewTime = day + hours + min
    },
    //
    filterFeaturesInputList(data) {
      data = data.filter((item) => {
        return item.text !== ''
      })
      return data
    },
    //完成评论
    finishedComment(id) {
      localStorage.setItem('finishedCommentId', id)
    },
    submit(submitType) {
      if (this.submiting) {
        return
      }
      this.submiting = true
      let merit =
        this.userinfo.p_type == 7 ? '' : this.getTagId(this.tagList, 0)
      let defect =
        this.userinfo.p_type == 7 ? '' : this.getTagId(this.tagList, 1)
      let trait =
        this.userinfo.p_type == 7
          ? this.getTagId(this.tagList, 0)
          : this.getTagId(this.tagList, 2)
      let trait_info =
        this.userinfo.p_type == 7
          ? JSON.stringify(this.filterFeaturesInputList(this.featuresInputList))
          : ''
      let params = {
        cid: this.coachId,
        id: this.userinfo.id || '',
        content: this.coachInput,
        merit,
        defect,
        trait,
        trait_info,
        p_show: submitType,
        anomalous: this.exceptionInput
      }
      this.scoreData?.map((item, index) => {
        params[this.scoreParams[index + '']] = item.score
      })
      this.$http
        .postApp('member/AppCampCoach/saveCoachComment', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.$toast(this.submitTypeArr[submitType] + '成功')
            localStorage.removeItem('coachInput-' + this.userinfo.id)
            localStorage.removeItem('exceptionInput-' + this.userinfo.id)
            this.finishedComment(this.userinfo.id)
            setTimeout(() => {
              this.$router.go(-1)
            }, 1000)
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          this.submiting = false
        })
    },
    bindBack() {
      wx.showModal({
        title: '提示',
        content: '是否保存评论内容及异常描述到本地草稿？',
        success: (res) => {
          if (res.confirm) {
            wx.setStorageSync('coachSaveStorage', this.data)
          } else if (res.cancel) {
          }
        },
        complete: () => {
          wx.navigateBack({
            delta: 0
          })
        }
      })
    },
    //处理emoji
    dealEmoji(data) {
      data = data.replace(/%/g, '%25')
      data = decodeURIComponent(data || '')
      return data
    },
    initDetail() {
      let userinfo = this.userinfo
      let typeArr = [3, 6, 7] //饮食打卡和全餐打卡类型
      if (typeArr.indexOf(userinfo.p_type) < 0 || userinfo.curMeal == 3) {
        this.minLength = 10
      }
      userinfo.p_content = this.dealEmoji(userinfo.p_content)
      this.coachInput = userinfo.p_content || ''
      this.exceptionInput = userinfo.anomalous || ''
      this.disabledSubmit = userinfo.p_show == 1
      this.canEdit = userinfo.p_show != 1
      this.computeTime()
    },
    getDetail() {
      let params = {
        tab_type: this.tab_type,
        tid: this.id
      }
      this.$http.getApp('member/AppCamp/getGroup', params).then((res) => {
        res = res.data
        if (res.code == 200) {
          let data = this.dealData(res.data)
          let queryData = JSON.parse(this.$route.query.detailData || '{}')
          this.userinfo = Object.assign(queryData, data)
          this.watchInput()
          this.initDetail()
          this.getLabelData()
          this.updateFeaturesInput(this.userinfo.trait_info)
          if (!data.p_show) {
            let coachInput = localStorage.getItem(
              'coachInput-' + this.userinfo.id
            )
            let exceptionInput = localStorage.getItem(
              'exceptionInput-' + this.userinfo.id
            )
            if (coachInput) {
              this.coachInput = coachInput
            }
            if (exceptionInput) {
              this.exceptionInput = exceptionInput
            }
          }
        } else {
          this.$toast(res.msg)
        }
      })
    },
    watchInput() {
      this.$watch(
        'coachInput',
        () => {
          console.log('更新了')
          localStorage.setItem(
            'coachInput-' + this.userinfo.id,
            this.coachInput
          )
        },
        {
          deep: true
        }
      )
      this.$watch(
        'exceptionInput',
        () => {
          console.log('更新了')
          localStorage.setItem(
            'exceptionInput-' + this.userinfo.id,
            this.exceptionInput
          )
        },
        {
          deep: true
        }
      )
    },
    //获取本地草稿数据
    getLocalStorage() {
      let data = JSON.parse(localStorage.getItem('coachSaveStorage'))
      if (data) {
        this.coachInput = data.coachInput
        this.exceptionInput = data.exceptionInput
        this.coachInput = data.coachInput
        localStorage.removeItem('coachSaveStorage')
      }
    },
    //更新饮食特点描述
    updateFeaturesInput(trait_info) {},
    dealData(data) {
      data.say = (data.say || '').replace(/%/g, '%25')
      data.p_content = (data.p_content || '').replace(/%/g, '%25')
      data.say = decodeURIComponent(data.say || '')
      data.p_content = decodeURIComponent(data.p_content || '')
      return data
    },
    //选择标签
    selectTag(index, index1) {
      let is_active = this.tagList[index].list[index1].active
      if (!is_active) {
        let selectNum = 0
        this.tagList[index].list.map((item) => {
          if (item.active) {
            selectNum++
          }
        })
        if (selectNum >= this.maxSelectTag) {
          return
        }
      }
      this.tagList[index].list[index1].active = !is_active
      let item = this.tagList[index].list[index1]
      if (
        this.userinfo.p_type == 7 &&
        !is_active &&
        this.featuresTextList[item.id]
      ) {
        this.coachInput += '\n\n' + this.featuresTextList[item.id].text
        this.coachInput = this.coachInput.slice(0, this.maxLength)
        this.coachInput = this.coachInput
      }
    },
    addFeatures(data) {
      let add = true
      //如果输入框列表中有这个相关的则不添加
      this.featuresInputList.map((item) => {
        if (item.id == data.id) {
          add = false
        }
      })
      if (add) {
        this.featuresInputList.push({
          id: data.id,
          title: data.name,
          text: this.featuresTextList[data.id].text,
          zIndex: this.featuresTextList[data.id].zIndex
        })
        this.updateDescText(this.featuresInputList)
      }
    },
    getLabelData() {
      this.$http.getApp('member/AppCampCoach/labelData', {}).then((res) => {
        res = res.data
        if (res.code == 200) {
          if (this.userinfo.p_type == 7) {
            res.data = [res.data[2]]
          }
          this.tagList = this.dealTag(res.data)
          this.updateSelectTag()
        }
      })
    },
    dealTag(data) {
      data.map((item) => {
        if (item.list) {
          item.list.map((item1) => {
            item1.active = false
          })
        }
      })
      return data
    },
    updateSelectTag() {
      this.tagList.map((item) => {
        item.list.map((item1) => {
          let labels = this.userinfo.p_label
          for (let i = 0; i < labels.length; i++) {
            if (item1.id == labels[i].id) {
              item1.active = true
            }
          }
        })
      })
    }
  }
}
</script>
<style lang="scss">
.old-page-content {
  .van-field__control::placeholder {
    color: #f04646;
  }

  .van-field__word-limit {
    font-size: 14px;
    color: rgba(56, 61, 72, 0.5);
  }
}
</style>
<style lang="scss" scoped>
.old-page-content {
  width: 100vw;
  min-height: 100vh;
  background-color: #f7f7f7;
}

.nav-bar {
  position: sticky;
  width: 100%;
  top: 0;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background-color: #f7f7f7;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  z-index: 999;
}

.nav-bar .nav-title {
  height: 40px;
  line-height: 40px;
}

.nav-bar .back {
  width: 40px;
  height: 40px;
  position: absolute;
  font-size: 20px;
  font-weight: 500;
  left: 0px;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dynamic-container {
  padding: 16px;
  box-sizing: border-box;
}

.all-ady-detail {
  width: 100%;
}

.circle-list {
  color: #000;
}

.circle-item {
  background-color: #fff;
  padding: 15px 16px;
  margin-bottom: 10px;
}

.circle-top {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.true-name {
  margin-right: 9px;
}

.name-content {
  width: 100%;
  display: flex;
}

.name-content .true-name {
  max-width: 70%;
  overflow: hidden;
}

.icon-nv-3 {
  color: rgb(255, 110, 110);
}

.icon-nan-5 {
  color: rgb(52, 153, 219);
}

.icon-wenhao4 {
  color: rgba(0, 0, 0, 0.5);
}

.circle-top .nickname {
  color: rgba(0, 0, 0, 0.5);
}

.avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  overflow: hidden;
}

.user-info {
  font-size: 12px;
  flex: 1;
  font-weight: 600;
  margin: 0px 9px;
  margin-bottom: 3px;
}

.coach-flag {
  display: inline-block;
  padding: 0px 7px;
  height: 14px;
  background-image: linear-gradient(180deg, #ff4e4e 0%, #ff2c55 100%);
  border-radius: 3px;
  font-size: 9px;
  color: #fff;
}

.not-attention {
  text-align: center;
  color: #fff;
  width: 60px;
  font-size: 13px;
  line-height: 24px;
  height: 24px;
  background-color: #f04646;
  border-radius: 12px;
}

.attention {
  text-align: center;
  color: #aaa;
  width: 60px;
  font-size: 13px;
  line-height: 24px;
  height: 24px;
  border-radius: 12px;
}

.content {
  font-size: 14px;
  margin-bottom: 10px;
  word-wrap: break-word;
}

.image-list {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.image-item {
  margin-bottom: 8px;
  width: 113px;
  height: 113px;
  object-fit: cover;
  border-radius: 5px;
}

.image-item-50 {
  width: 165px;
  height: 165px;
}

.image-item-100 {
  width: 336rpx;
  height: 336rpx;
}

.circle-bottom {
  color: #aaa;
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 12px;
  margin-bottom: 18px;
}

.circle-bottom .iconfont {
  color: #ccc;
  font-size: 18px;
  margin-right: 5px;
}

.circle-bottom .icon-like {
  color: #e5004a;
}

.comment-btn,
.like-btn {
  display: flex;
  align-items: center;
}

.comment-btn {
  margin-right: 20px;
}

.like-btn {
  margin-right: 20px;
}

.time {
  flex: 1;
  text-align: right;
}

.new-comment {
  background-color: #f7f7f7;
  border-radius: 5px;
  padding: 11px 16px;
  box-sizing: border-box;
  margin-bottom: 10px;
}

.comment-info {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.comment-avatar {
  width: 16px;
  height: 16px;
  background-color: #b4b4b4;
  border-radius: 4px;
  margin-right: 8px;
}

.comment-name {
  flex: 1;
  width: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-weight: 600;
  font-size: 12px;
  color: #000000;
}

.new-comment .comment {
  font-size: 12px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.6);
}

.zan-animate {
  width: 30px;
  height: 30px;
  transform: scale(1.8);
  background: url(https://cdnvue.gymcity.com.cn/uploads/a921d898ee1cd68867b4699a6f79bb69.png)
    no-repeat;
  background-position: left;
  background-size: cover;
}

.zan-animate-active {
  background-position: right;
  transition: background 0.6s steps(28);
}

.reviews {
  color: #fff;
  font-size: 15px;
  width: 336px;
  height: 36px;
  background-color: #3b4761;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.reviews .iconfont {
  margin-right: 10px;
}

.circle-center {
  margin-bottom: 20px;
}

.comment-container {
  position: relative;
  margin-bottom: 20px;
}

.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.comment-area {
  padding: 5px 5px 20px;
  font-size: 14px;
  box-sizing: border-box;
  width: 100%;
  height: 240px;
  background-color: #ffffff;
  border-radius: 6px;
  border: solid 1px #f1f1f1;
}

.comment-box {
  position: relative;
}

.fixed-area {
  padding: 10px 20px;
  box-sizing: border-box;
  background-color: #f7f7f7;
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
  z-index: 999;
}

.error-area {
  padding: 5px 5px 25px;
  font-size: 14px;
  box-sizing: border-box;
  width: 100%;
  height: 80px;
  background-color: #ffffff;
  border-radius: 6px;
  border: solid 1px #f1f1f1;
}

.score-content {
  background-color: #fff;
  border-radius: 6px;
  border: solid 1px #f1f1f1;
  margin-bottom: 28px;
  padding: 29px 23px;
  box-sizing: border-box;
}

.btn-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.btn-item {
  width: 168px;
  font-size: 14px;
  line-height: 36px;
  text-align: center;
  height: 36px;
  border-radius: 8px;
}

.save-btn {
  background-color: #fff;
  color: #000;
}

.release-btn {
  color: #fff;
  background-color: #f04646;
}

.tag-content {
  display: flex;
}

.tag-list {
  display: flex;
  flex: 1;
  overflow: hidden;
  align-items: center;
  flex-wrap: wrap;
}

.tag-item {
  height: 28px;
  padding: 0px 16px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
  line-height: 28px;
  white-space: nowrap;
  background-color: #fff;
  border-radius: 13px;
  border: solid 1px #f1f1f1;
  margin-right: 8px;
  margin-bottom: 10px;
}

.tag-item-active {
  border: solid 1px #3b4761;
  color: #000;
}

.tag-type {
  line-height: 28px;
  font-size: 14px;
  color: #000;
  margin-right: 14px;
}

.del-content {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 20px 0px;
}

.del-btn {
  color: #fff;
  font-size: 14px;
  text-align: center;
  width: 75px;
  height: 25px;
  line-height: 25px;
  background-color: #f04646;
  border-radius: 6px;
}

.disabled-release {
  background-color: #aaa;
}

.label-list {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.label-list .tag-item {
  font-size: 13px;
  line-height: 30px;
  height: 30px;
  background-color: #e9f0f9;
  border-radius: 15px;
  padding: 0px 11px;
  border-radius: 15px;
  margin-right: 10px;
  margin-bottom: 5px;
  font-size: 12px;
  color: #7781a2;
}

.review-time,
.add-time,
.review-duration {
  font-size: 12px;
  color: #aaa;
}

.review-time {
  text-align: center;
  margin-bottom: 10px;
}

.review-duration {
  text-align: center;
}

.add-time {
  text-align: right;
}

.today-reviews {
  font-family: PingFangSC-Medium;
  font-size: 12px;
  color: #2882e9;
}

.features-input-list {
  margin-bottom: 10px;
}

.features-input-item .close {
  position: absolute;
  top: 15px;
  right: 16px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #f7f7f7;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #d8d8d8;
}

.features-input-item .add {
  position: absolute;
  top: 15px;
  right: 55px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #f7f7f7;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #d8d8d8;
}

.features-input-list .features-input-item {
  position: relative;
  padding: 11px 17px;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 6px;
  border: 1px solid #f1f1f1;
  margin-bottom: 5px;
}

.features-input-list .features-input-item:last-child {
  margin-bottom: 0px;
}

.features-input-item .item-title {
  font-size: 16px;
  height: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: rgba(0, 0, 0, 0.5);
  line-height: 24px;
  margin-bottom: 12px;
}

.features-input-item .rotate {
  transform: rotate(45deg);
}

.features-input-item .item-input {
  height: 144px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: rgba(0, 0, 0, 0.8);
  line-height: 24px;
}

.data-diff {
  margin-top: 6px;
  font-size: 14px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.8);
}

.data-info {
  margin-top: 19px;
  border-bottom: 1px solid #f2f2f2;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 10px;

  .data-item {
    width: 111px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
    .d-text {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.5);
      margin-right: 8px;
      height: 17px;
      line-height: 17px;
    }

    .d-num {
      font-size: 14px;
      font-family: DINCondensed-Bold, DINCondensed;
      font-weight: bold;
      height: 17px;
      line-height: 20px;
      color: rgba(0, 0, 0, 0.8);
      margin-right: 2px;
    }

    .d-unit {
      font-size: 10px;
      font-family: DINCondensed-Bold, DINCondensed;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.8);
      margin-right: 4px;
      height: 17px;
      line-height: 22px;
    }

    .d-div {
      width: 24px;
      height: 12px;
      background: #35c763;
      box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.05);
      border-radius: 3px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;

      .iconfont {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 4px;
        height: 8px;
        line-height: 8px;
        font-size: 8px;
      }

      .rotate {
        transform: rotate(180deg);
        transform-origin: center center;
      }

      .change-num {
        margin-left: 4px;
        height: 12px;
        line-height: 15px;
        font-size: 10px;
        font-family: DINCondensed-Bold, DINCondensed;
        font-weight: bold;
      }
    }

    .d-red {
      background-color: #f04646;
    }

    .d-green {
      background-color: #35c763;
    }
  }

  .data-item::after {
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(0%, -50%);
    width: 1px;
    height: 6px;
    background-color: #e4e4e4;
  }

  .data-item:last-child::after {
    display: none;
  }
}
</style>
